// extracted by mini-css-extract-plugin
module.exports = {"desktopMenu":"styles_desktopMenu__JAxfO","mobileMenuIcon":"styles_mobileMenuIcon__cztAm","drawer":"styles_drawer__x_dAf"};